import { skipToken } from "@tanstack/react-query";
import { selectSelectedArchivedElementId } from "@v1/reducers/core-reducer";
import { useEditorSelector } from "@v1/store/store";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { elementRouter } from "@v2/trpc/routes/element";

export function useSelectedArchivedElement() {
  const projectId = useCurrentProjectId();
  const { data: archivedElements } = elementRouter.listArchived.useQuery(
    projectId ? { projectId } : skipToken,
  );
  const selectedArchivedElementId = useEditorSelector(
    selectSelectedArchivedElementId,
  );

  if (!archivedElements) {
    return null;
  }

  return archivedElements.find(
    (element) => element.id === selectedArchivedElementId,
  );
}
